import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { throwIfAlreadyLoaded } from '../helpers/module-import-guard';
import { AuthInterceptor } from './interceptors/auth-interceptor.service';
import { OktaService } from './services/okta.service';
import { SecurityConfigService } from './security-config.service';
import { PermissionGuardDirective } from './guards/permission-guard.directive';
import { AuthenticationService } from './services/authentication.service';
import { AuthEventService } from './services/auth.events.service';
import { AccessControlService } from './access-control/access-control.service';

import { PermissionGuard } from './guards/permission-guard.service';
import { AuthenticationGuard } from './guards/authentication-guard.service';
import { SecuritySharedModule } from './security-shared.module';

@NgModule({
  imports: [
    CommonModule,
    SecuritySharedModule,
    HttpClientModule
  ],
  providers: [
    [
      SecurityConfigService,
      AuthenticationService,
      AuthEventService,
      AccessControlService,
      AuthenticationGuard,
      PermissionGuard,
      OktaService
    ]
  ]
})
export class SecurityModule {
  constructor( @Optional() @SkipSelf() parentModule: SecurityModule) {
    throwIfAlreadyLoaded(parentModule, 'SecurityModule');
  }
}




// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/security/security.module.ts